import "./imagesmanager.css";
import { useNavigate } from "react-router-dom";

const Svg = ({ children, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcSlider  = () => <Svg><rect x="3" y="6" width="18" height="12" rx="2" /><circle cx="8" cy="12" r="2" /><polyline points="14 12 18 12" /></Svg>;
const IcHome    = () => <Svg><path d="M3 9.5 12 3l9 6.5V21a2 2 0 0 1-2 2h-4v-7h-6v7H5a2 2 0 0 1-2-2z" /></Svg>;
const IcGallery = () => <Svg><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></Svg>;
const IcArrow   = () => <Svg size={16}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></Svg>;

const SECTIONS = [
  {
    key: "slider",
    title: "Slider manager",
    description: "Hero slides shown at the top of the booking website homepage. Update the rotating banner that greets your guests first.",
    icon: <IcSlider />,
    accent: "blue",
  },
  {
    key: "home_gallerie",
    title: "Home gallery",
    description: "The featured photo grid that lives on the home page below the hero. Choose the most enticing shots of your property.",
    icon: <IcHome />,
    accent: "orange",
  },
  {
    key: "gallerie",
    title: "Full gallery",
    description: "The complete photo library shown on the dedicated gallery page. Add or remove pictures shown to potential guests.",
    icon: <IcGallery />,
    accent: "green",
  },
];

const ImagesManager = () => {
  const navigate = useNavigate();

  return (
    <div className="cm-page">
      <header className="cm-hero">
        <div>
          <span className="cm-hero__eyebrow">Marketing content</span>
          <h1 className="cm-hero__title">Content & galleries</h1>
          <p className="cm-hero__sub">
            Manage the imagery shown on your booking website. Pick which area to
            update — hero slider, home gallery, or the full gallery page.
          </p>
        </div>
      </header>

      <div className="cm-grid">
        {SECTIONS.map((s) => (
          <button
            key={s.key}
            type="button"
            className={`cm-card cm-card--${s.accent}`}
            onClick={() => (window.location += "/" + s.key)}
          >
            <span className="cm-card__icon">{s.icon}</span>
            <div className="cm-card__body">
              <h3>{s.title}</h3>
              <p>{s.description}</p>
            </div>
            <span className="cm-card__arrow"><IcArrow /></span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ImagesManager;
